import { PDxPOFileType } from "src/app/core/PDxPOFileType.enum";
import { PDxTransmissionMethod } from "src/app/core/PDxTransmissionMethod.enum";
import { UploadResult } from "src/app/core/upload-result.model";

export class VendorInformation {
    constructor() {
        this.isActive = true;
        this.state = null;
        this.poTransmissionMethod = PDxTransmissionMethod.Email;
        this.poFileType = PDxPOFileType.PDF;
    }

    vendorId: string;
    vendorName: string;
    isActive: boolean;
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    postalCode: string;
    primaryContactFirstName: string;
    primaryContactLastName: string;
    primaryContactEmail: string;
    primaryContactPhone: string;
    phoneNumber: string;
    faxNumber: string;
    poTransmissionMethod: PDxTransmissionMethod;
    poFileType: PDxPOFileType;
    poEmailAddress: string;
    poEFaxAddress: string;
    poSFTPServer: string;
    poSFTPDirectory: string;
    poSFTPInboundDirectory: string;
    poSFTPUsername: string;
    poSFTPPassword: string;
    termsURL: string;

    stockingSFTPServer: string;
    stockingSFTPDirectory: string;
    stockingSFTPUsername: string;
    stockingSFTPPassword: string;

    fullAddress: string;
    poTransmissionMethodDisplay: string;
    poFileTypeDisplay: string;
    hasPrimaryContact: boolean;

    ediFileExtension: string;
    ediFilePrefix: string;
    ediReceiverID: string;
    ediReceiverIDQualifier: string;
    ediSenderID: string;
    ediUseBillingNumber: boolean;
    ediAddressCodeQualifier: string;
    ediIncludeMFInformation: boolean;
    ediIncludePriceUOM: boolean;
    ediIncludeNDCInformation: boolean;

    logo?: UploadResult;

    hasStatusList: boolean;
}